import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-2/5 my-5" }
const _hoisted_2 = {
  class: "font-medium text-gray-600 dark:text-gray-300 cursor-pointer",
  for: "inputfile"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "grid absolute bottom-0 right-0 w-1/4 h-1/4 c-field--button border-2 overflow-hidden border-white rounded-full justify-items-center transition-all hover:bg-indigo-500 ease-in-out duration-300" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-red-500 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([{'has-file': _ctx.showRemovedBtn, 'error' : _ctx.error}, "relative inline-box items-center justify-center w-35 h-35 overflow-hidden"])
    }, [
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("img", {
          alt: "Imagem de perifl",
          src: _ctx.image ?? '/logo-white.png',
          class: "w-full h-full mx-auto inline-block object-cover w-12 h-12 rounded-full"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FontAwesomeIcon, {
            icon: _ctx.uploadIcon,
            class: "w-3/5 h-3/5 self-center text-white"
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("input", {
          id: "inputfile",
          ref: "imageUploader",
          placeholder: "Imagem de perfil",
          title: "Imagem de perfil",
          type: "file",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetFile && _ctx.resetFile(...args))),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fileChangeHandler && _ctx.fileChangeHandler(...args))),
          name: "attachment",
          class: "c-file-input__field js-file-input__field"
        }, null, 544)
      ])
    ], 2),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true)
  ]))
}